// Ported verbatim from fuckable (pages/Video.js SubscriptionPopup).
// Paywall: pick a tier → Centrobill subscription checkout. Reuses the
// fuck-pricing-* styles. If the visitor isn't logged in, route them
// through login first instead of a dead button.
import { useState, useEffect } from 'react';
import { createSubscription } from '@genfun/core/api/auth';
import { openTabWithUrl } from '@genfun/core/utils/openTabWithUrl';
import './SubscriptionPopup.css';

// Locks background scroll while the popup is open (body + html overflow,
// compensates for the scrollbar width). Same lock used across d33p popups.
function useLockBodyScroll(isOpen) {
    useEffect(() => {
        if (!isOpen) return;
        const html = document.documentElement;
        const body = document.body;
        const scrollbarWidth = window.innerWidth - html.clientWidth;
        const prev = {
            bodyOverflow: body.style.overflow,
            htmlOverflow: html.style.overflow,
            bodyPaddingRight: body.style.paddingRight,
        };
        body.style.overflow = 'hidden';
        html.style.overflow = 'hidden';
        if (scrollbarWidth > 0) body.style.paddingRight = `${scrollbarWidth}px`;
        return () => {
            body.style.overflow = prev.bodyOverflow;
            html.style.overflow = prev.htmlOverflow;
            body.style.paddingRight = prev.bodyPaddingRight;
        };
    }, [isOpen]);
}

export function SubscriptionPopup({ isOpen, onClose, token, onNeedLogin }) {
    const [loading, setLoading] = useState(null);
    useLockBodyScroll(isOpen);

    const handleSubscribe = (tier) => {
        if (!token) { onNeedLogin?.(); return; }
        setLoading(tier);
        openTabWithUrl(() => createSubscription(token, tier).then((r) => r.url))
            .catch((e) => console.error(e))
            .finally(() => setLoading(null));
    };

    if (!isOpen) return null;

    return (
        <div className="fuck-pricing-overlay" onClick={onClose}>
            <div className="fuck-pricing-popup" onClick={(e) => e.stopPropagation()}>
                <button className="fuck-pricing-close" onClick={onClose}>&times;</button>
                <h2>Pick your subscription</h2>
                <p>Unlock unlimited creating — billed monthly, cancel anytime.</p>
                <div className="fuck-pricing-cards">
                    <div className="fuck-pricing-card">
                        <div className="fuck-pricing-name">Starter</div>
                        <div className="fuck-pricing-price">$9.99<span className="fuck-pricing-per">/mo</span></div>
                        <ul>
                            <li>50 tokens / month</li>
                            <li>≈ 16 photos or 5 videos</li>
                            <li>No watermark</li>
                            <li>Cancel anytime</li>
                        </ul>
                        <button onClick={() => handleSubscribe(1)} disabled={!!loading}>
                            {loading === 1 ? 'Redirecting…' : 'Buy'}
                        </button>
                    </div>
                    <div className="fuck-pricing-card fuck-pricing-card--popular">
                        <div className="fuck-pricing-badge">Best value</div>
                        <div className="fuck-pricing-name">Premium</div>
                        <div className="fuck-pricing-price">$25<span className="fuck-pricing-per">/mo</span><s>$60</s></div>
                        <ul>
                            <li>200 tokens / month</li>
                            <li>≈ 66 photos or 20 videos</li>
                            <li>Priority queue</li>
                            <li>Cancel anytime</li>
                        </ul>
                        <button className="fuck-pricing-buy--primary" onClick={() => handleSubscribe(2)} disabled={!!loading}>
                            {loading === 2 ? 'Redirecting…' : 'Buy'}
                        </button>
                    </div>
                </div>
                <div className="fuck-pricing-footnote">
                    Secure checkout via Centrobill. You can cancel from your account at any time.
                </div>
            </div>
        </div>
    );
}
